// Есть ли связь с сервером: браузер говорит «нет сети» или запрос упал без ответа сервера.
// Когда связь вернулась, TanStack Query сам повторяет запросы, и опрос заказа продолжается.
import { onlineManager, useQueryClient } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";
import { isApiError } from "../api/client";

function subscribeOnline(notify: () => void): () => void {
  return onlineManager.subscribe(notify);
}

function isOnline(): boolean {
  return onlineManager.isOnline();
}

export function useConnectionLost(): boolean {
  const online = useSyncExternalStore(subscribeOnline, isOnline, () => true);
  const queryClient = useQueryClient();
  const queryCache = queryClient.getQueryCache();
  const requestFailed = useSyncExternalStore(
    (notify) => queryCache.subscribe(notify),
    // Последний запрос не дошёл до сервера; после удачного повтора счётчик обнуляется.
    () =>
      queryCache
        .getAll()
        .some(
          (query) =>
            query.state.fetchFailureCount > 0 &&
            isApiError(query.state.fetchFailureReason) &&
            query.state.fetchFailureReason.kind === "network",
        ),
    () => false,
  );
  return !online || requestFailed;
}
